/*
 * assets/cart-recommendations.js — Vivid Agency, 11.09.2026
 * Produktempfehlungen im NOELIE Cart Drawer (#sidebar-cart, Prestige v4 / [VIV] NOELIE v2.07.6)
 *
 * Karten-Quelle: vorhandene Theme-Section "product-recommendations", abgerufen über
 * /recommendations/products?section_id=product-recommendations&product_id=…&intent=related
 * Dadurch identisches Kartenmarkup (.Carousel__Cell > ProductItem inkl. Judge.me-Badge),
 * keine neue Section und keine Änderung an Core-Dateien nötig.
 *
 * Aktualisierung: das Theme ersetzt bei jeder Warenkorbänderung den Inhalt von
 * #sidebar-cart per innerHTML. Der Container kommt dadurch leer und ohne State-Attribut
 * zurück — ein MutationObserver auf #sidebar-cart genügt als Trigger, ein fetch-Wrapper
 * (wie in gift-product-1.js) wird nicht dupliziert.
 */
(function () {
  'use strict';

  var DRAWER_SELECTOR = '#sidebar-cart';
  var SECTION_ID = 'product-recommendations';
  var CARD_SELECTOR = '.Carousel__Cell';
  var MAX_CARDS = 4;
  var MAX_SEEDS = 2; // wie viele Warenkorbprodukte als Empfehlungsbasis dienen
  var DEBOUNCE = 150;

  var timer = null;
  var busy = false;

  function drawerEl() { return document.querySelector(DRAWER_SELECTOR); }
  function blockEl() { return document.querySelector('[data-cart-recos]'); }
  function trackEl() { return document.querySelector('[data-cart-recos-track]'); }

  function isDrawerOpen() {
    var d = drawerEl();
    return !!d && d.getAttribute('aria-hidden') === 'false';
  }

  function handleFromHref(href) {
    if (!href) return null;
    var match = href.split('?')[0].match(/\/products\/([^/]+)\/?$/);
    return match ? match[1] : null;
  }

  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) {
      return r.json();
    });
  }

  function fetchCards(productId) {
    var url = '/recommendations/products?section_id=' + SECTION_ID +
      '&product_id=' + productId + '&limit=' + MAX_CARDS + '&intent=related';

    return fetch(url)
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        if (!html) return [];
        var doc = new DOMParser().parseFromString(html, 'text/html');
        return Array.prototype.slice.call(doc.querySelectorAll(CARD_SELECTOR));
      })
      .catch(function () { return []; });
  }

  /* Warenkorbprodukte als Empfehlungsbasis. Geschenkzeilen (0 €, u. a. von DiscountYard
     automatisch eingefügt) taugen nicht als Basis und werden übersprungen. */
  function seedIds(cart) {
    var paid = cart.items.filter(function (item) { return item.price > 0; });
    var source = paid.length ? paid : cart.items;
    var ids = [];

    source.forEach(function (item) {
      if (ids.indexOf(item.product_id) === -1) ids.push(item.product_id);
    });

    return ids.slice(0, MAX_SEEDS);
  }

  function buildCards(cart) {
    var ids = seedIds(cart);
    if (!ids.length) return Promise.resolve([]);

    var inCart = cart.items.map(function (item) { return item.handle; });

    return Promise.all(ids.map(fetchCards)).then(function (groups) {
      var seen = [];
      var cards = [];

      groups.forEach(function (group) {
        group.forEach(function (cell) {
          var link = cell.querySelector('a[href*="/products/"]');
          var handle = handleFromHref(link && link.getAttribute('href'));

          if (!handle) return;
          if (inCart.indexOf(handle) !== -1) return;
          if (seen.indexOf(handle) !== -1) return;

          seen.push(handle);
          cards.push(cell);
        });
      });

      return cards.slice(0, MAX_CARDS);
    });
  }

  function inject(track, cards) {
    var fragment = document.createDocumentFragment();

    cards.forEach(function (cell) {
  var item = cell.cloneNode(true);
  item.classList.remove('Carousel__Cell'); // Flickity-Positionierung abstreifen
  item.classList.add('CartRecos__Item');

  var title = item.querySelector('.ProductItem__Title');
  if (title) {
    title.classList.remove('ProductItem__Title');
    title.classList.add('CartItem__Title');
  }

  fragment.appendChild(item);
});

    track.innerHTML = '';
    track.appendChild(fragment);

    // Prestige lädt Bilder über lazysizes (Image--lazyLoad + data-src) — nachgeschobene
    // Knoten sicherheitshalber aktiv anstoßen.
    if (window.lazySizes && window.lazySizes.loader) window.lazySizes.loader.checkElems();
  }

  /* ---------- Fortschrittsanzeige + Drag-to-Scroll ---------- */

  function setupInteractions(track) {
    var progress = document.querySelector('[data-cart-recos-progress]');
    var fill = document.querySelector('[data-cart-recos-fill]');

    function update() {
      if (!progress || !fill) return;

      var maxScroll = track.scrollWidth - track.clientWidth;

      if (maxScroll <= 4) {
        progress.hidden = true;
        return;
      }

      progress.hidden = false;

      var ratio = track.clientWidth / track.scrollWidth;
      var position = Math.min(Math.max(track.scrollLeft / maxScroll, 0), 1);

      fill.style.width = (ratio * 100) + '%';
      fill.style.marginLeft = (position * (100 - ratio * 100)) + '%';
    }

    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    requestAnimationFrame(update);

    var isDown = false;
    var dragged = false;
    var startX = 0;
    var scrollStart = 0;

    track.addEventListener('mousedown', function (event) {
      isDown = true;
      dragged = false;
      startX = event.pageX;
      scrollStart = track.scrollLeft;
    });

    track.addEventListener('mousemove', function (event) {
      if (!isDown) return;

      var walk = event.pageX - startX;
      if (Math.abs(walk) > 4) {
        dragged = true;
        track.classList.add('is-dragging');
      }

      event.preventDefault();
      track.scrollLeft = scrollStart - walk;
    });

    function stop() {
      isDown = false;
      track.classList.remove('is-dragging');
    }

    track.addEventListener('mouseup', stop);
    track.addEventListener('mouseleave', stop);

    // Nach einem Drag darf der darunterliegende Produktlink nicht auslösen.
    track.addEventListener('click', function (event) {
      if (!dragged) return;
      event.preventDefault();
      event.stopPropagation();
      dragged = false;
    }, true);
  }

  /* ---------- Ablauf ---------- */

  function render() {
    var track = trackEl();
    var block = blockEl();

    if (!track || !block || busy) return;
    if (track.dataset.crState) return; // in diesem Render-Zyklus schon erledigt

    busy = true;
    track.dataset.crState = 'loading';

    getCart()
      .then(function (cart) {
        if (!cart.item_count) return [];
        return buildCards(cart);
      })
      .then(function (cards) {
        if (!cards.length) {
          track.dataset.crState = 'none';
          block.hidden = true;
          return;
        }

        inject(track, cards);
        block.hidden = false;
        track.dataset.crState = 'done';
        setupInteractions(track);
      })
      .catch(function (error) {
        track.dataset.crState = 'error';
        console.error('CartRecommendations:', error);
      })
      .then(function () { busy = false; });
  }

  function schedule() {
    if (!isDrawerOpen()) return;

    var track = trackEl();
    if (!track || track.dataset.crState) return;

    clearTimeout(timer);
    timer = setTimeout(render, DEBOUNCE);
  }

  function observe(drawer) {
    new MutationObserver(schedule).observe(drawer, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['aria-hidden']
    });

    schedule(); // Fall: Drawer ist beim Laden bereits offen
  }

  function init() {
    var drawer = drawerEl();

    if (drawer) {
      observe(drawer);
      return;
    }

    // Drawer noch nicht im DOM — einmalig nachfassen.
    var bodyObserver = new MutationObserver(function () {
      var found = drawerEl();
      if (!found) return;
      bodyObserver.disconnect();
      observe(found);
    });

    bodyObserver.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();